<template>
  <div class="container">
    <div class="event-description">
      {{ text }}
    </div>
    <div class="button-box">
      <owal-banner-button
        v-show="canAcessOperation('view_historic')"
        type="static"
        title="View Clip"
        accessory-type="none"
        identifier="button"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script>
import { OwalBannerButton } from '@/libraries/owal-ui/'
import { mapGetters } from 'vuex'

export default {
  name: 'EventsBannerSlot',
  components: { OwalBannerButton },
  props: ['text', 'cameraId', 'timestamp'],
  methods: {
    handleClick () {
      this.$router.push(`/view/${this.cameraId}/${this.timestamp}`)
    },
  },
  computed: {
    ...mapGetters({
      canAcessOperation: 'entitlements/canPerformOperationForCurrentService',
    }),
  },
}
</script>

<style scoped>
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .event-description {
    font-size: 1.71rem;
    font-family: 'Lato';
    font-weight: bold;
  }
  .button-box {
    align-self: flex-end;
    margin-right: 2%;
    margin-left: auto;
    display: flex;
    flex-shrink: 0;
  }
</style>
